import type { UserInputValidationError } from '@tectonics/prs/validation';

import { DIRECT_DEBIT } from './nigerian-bank-code';

export function isDirectDebitSelected(selectedPaymentMethod: string, selectedEwallet: string): boolean {
  return selectedPaymentMethod === 'ewallet' && selectedEwallet === DIRECT_DEBIT;
}

export function validateRequiredDirectDebitField(
  selectedPaymentMethod: string,
  selectedEwallet: string,
  value: string
): UserInputValidationError | undefined {
  if (!isDirectDebitSelected(selectedPaymentMethod, selectedEwallet)) {
    return undefined;
  }

  return !value || value.trim() === '' ? { id: 'empty' } : undefined;
}
